(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6290,6107],{

/***/ 10375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_StudyDestination; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/StudyDestination.module.scss
var StudyDestination_module = __webpack_require__(90784);
var StudyDestination_module_default = /*#__PURE__*/__webpack_require__.n(StudyDestination_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./components/WebinarEvents.tsx
var WebinarEvents = __webpack_require__(72350);
// EXTERNAL MODULE: ./components/FeaturedBlogs.tsx
var FeaturedBlogs = __webpack_require__(85684);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 14 modules
var Form = __webpack_require__(97346);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/UniTieUp.tsx
var UniTieUp = __webpack_require__(97761);
// EXTERNAL MODULE: ./components/UI/TabNav/TabNav.module.scss
var TabNav_module = __webpack_require__(12978);
var TabNav_module_default = /*#__PURE__*/__webpack_require__.n(TabNav_module);
;// CONCATENATED MODULE: ./components/UI/TabNav/TabNav.tsx



const TabNav = ({ items , activeId , onSelect  })=>{
    if (!items || items.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: (TabNav_module_default()).tabNav,
        "aria-label": "Section navigation",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (TabNav_module_default()).edgeFadeLeft
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (TabNav_module_default()).tabNavScroller,
                children: items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: `${(TabNav_module_default()).tabNavItem} ${activeId === item.id ? (TabNav_module_default()).active : ""}`,
                            onClick: ()=>onSelect(item),
                            children: item.label
                        })
                    }, item.id))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (TabNav_module_default()).edgeFadeRight
            })
        ]
    });
};
/* harmony default export */ var TabNav_TabNav = (TabNav);

// EXTERNAL MODULE: ./components/kcNewlatestupdates.tsx
var kcNewlatestupdates = __webpack_require__(79465);
// EXTERNAL MODULE: ./components/PST/FrequentlyAskedQuestions.tsx
var FrequentlyAskedQuestions = __webpack_require__(3011);
// EXTERNAL MODULE: ./components/PST/VideoTestimonials.tsx
var VideoTestimonials = __webpack_require__(55689);
// EXTERNAL MODULE: ./components/NewNeedGuidance.tsx
var NewNeedGuidance = __webpack_require__(56560);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
// EXTERNAL MODULE: ./utils/applyCtaButtonProps.ts
var utils_applyCtaButtonProps = __webpack_require__(78409);
// EXTERNAL MODULE: ./utils/b2c/constants.ts
var constants = __webpack_require__(90017);
// EXTERNAL MODULE: ./utils/b2c/sourceTracking.ts
var sourceTracking = __webpack_require__(3265);
;// CONCATENATED MODULE: ./components/StudyDestination.tsx























const StudyDestination = (props)=>{
    const router = (0,next_router.useRouter)();
    const { query  } = router;
    const studyDestinationData = props?.pageData;
    const { 0: selectedDestination , 1: setSelectedDestination  } = (0,react.useState)(query.slug ? props?.countryData[0]?.studycountries[0] : props?.pageData?.studycountries[0]);
    const { 0: searchDestination , 1: setSearchDestination  } = (0,react.useState)("");
    const bannerToOnboardingEnabled = studyDestinationData?.bannerBtn?.toOnboardingEnabled;
    const applyCtaButtonProps = (0,utils_applyCtaButtonProps/* getOnboardingOrFormCtaProps */.J)(router, {
        btnLink: studyDestinationData?.bannerBtn?.btnLink,
        formId: studyDestinationData?.bannerBtn?.formId || (bannerToOnboardingEnabled ? undefined : "main-enquiry-form"),
        toOnboardingEnabled: bannerToOnboardingEnabled
    });
    (0,react.useEffect)(()=>{
        window.addEventListener("scroll", renderStickyHeader);
        return ()=>{
            window.removeEventListener("scroll", renderStickyHeader);
        };
    });
    const renderStickyHeader = ()=>{
        const header = document.getElementById("header");
        const scrollTop = window.scrollY;
        const startScroll = window.screen.width <= 900 ? 2100 : 1200;
        scrollTop >= startScroll && header ? header?.classList.add((StudyDestination_module_default()).headerDisplay) : header?.classList.remove((StudyDestination_module_default()).headerDisplay);
    };
    const studyCountries = query.slug ? props?.countryData[0]?.studycountries : props?.pageData?.studycountries;
    const enquireNowClickHandler = (e)=>{
        if (applyCtaButtonProps.mode === "onboarding") {
            (0,sourceTracking/* persistSourceContext */.jW)({
                sourceUrl: window.location.href,
                primarySource: constants/* PRIMARY_SOURCE_B2C_WIDGET */.ov,
                fifthStepVisible: studyDestinationData?.bannerBtn?.onBoardingFlow?.nearestOffice ?? true,
                coachingVisible: studyDestinationData?.bannerBtn?.onBoardingFlow?.lookingForCoaching ?? true
            });
        }
        applyCtaButtonProps.onClick?.(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (StudyDestination_module_default()).stickyHead,
                id: "header",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabNav_TabNav, {
                    items: studyCountries.length > 0 ? studyCountries.map((studyDestination)=>({
                            id: studyDestination.id,
                            label: studyDestination.title
                        })) : [],
                    activeId: selectedDestination?.id,
                    onSelect: (item)=>{
                        const studyDestination = studyCountries.find((country)=>country.id === item.id);
                        setSelectedDestination(studyDestination);
                        if (query.slug) {
                            router.push(`/study-destinations/${query.slug}#${studyDestination.title.replace(/ /g, "")}`);
                        } else router.push(`/study-destinations#${studyDestination.title.replace(/ /g, "")}`);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "study-destination",
                className: (StudyDestination_module_default()).studyDestinationBg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                xs: 12,
                                lg: 7,
                                className: (StudyDestination_module_default()).mainContent,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                        className: (StudyDestination_module_default()).breadcrum,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                style: {
                                                    opacity: 0.5
                                                },
                                                href: "/",
                                                children: "Home"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                href: "",
                                                children: "Study Destinations"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "mb-3",
                                        children: props?.countryData?.length > 0 && props?.countryData[0]?.mainTitle || props?.pageData?.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: props?.countryData?.length > 0 && props?.countryData[0]?.mainDescription || props?.pageData?.description
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: "primary",
                                        size: "lg",
                                        onClick: enquireNowClickHandler,
                                        className: `btn ${applyCtaButtonProps.formClassName}`,
                                        children: props?.pageData?.bannerBtn?.label || "Enquire Now"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                lg: 5,
                                className: `${(StudyDestination_module_default()).globe} text-center`,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: props?.countryData?.length > 0 && props?.countryData[0]?.mainImageUrl || props?.pageData?.mainImageUrl,
                                    alt: props?.countryData?.length > 0 && props?.countryData[0]?.mainImageAltTag || props?.pageData?.mainImageAltTag,
                                    width: 525,
                                    height: 525
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "search-studydesti",
                className: (StudyDestination_module_default()).searchStudyDesti,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (StudyDestination_module_default()).searchPan,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (StudyDestination_module_default()).searchBox,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-center",
                                children: "Search your Study Destination"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (StudyDestination_module_default()).subscribeForm,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Select */.Z.Select, {
                                            placeholder: "Select Country",
                                            onChange: (event)=>setSearchDestination(event.target.value),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    children: "Select Country"
                                                }),
                                                studyCountries.length > 0 && studyCountries.map((destination, index)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        children: destination.title
                                                    }, index);
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            onClick: ()=>{
                                                if (searchDestination && searchDestination !== "Select Country") {
                                                    const filteredDestination = studyCountries.filter((country)=>country.title === searchDestination)[0];
                                                    setSelectedDestination(filteredDestination);
                                                    if (query.slug) {
                                                        router.push(`/study-destinations/${query.slug}#${filteredDestination.title.replace(/ /g, "")}`);
                                                    } else router.push(`/study-destinations#${filteredDestination.title.replace(/ /g, "")}`);
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: "/new-images/search-sign.svg",
                                                    width: 19,
                                                    height: 19,
                                                    alt: "searchSign.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (StudyDestination_module_default()).searchtxt,
                                                    children: "Search"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "our-strengths",
                className: (StudyDestination_module_default()).Strengths,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-center mb-5",
                            children: "Our Strengths"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: "text-center",
                            children: props?.pageData?.ourStrengths?.length > 0 && props?.pageData?.ourStrengths?.map((section)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    md: 4,
                                    lg: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (StudyDestination_module_default()).StrengthsContent,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: section.imagePath,
                                                    width: 105,
                                                    height: 75,
                                                    alt: section.imageAltTag
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: section?.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: section?.description
                                            })
                                        ]
                                    })
                                }, section?.id);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "study-countriess",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (StudyDestination_module_default()).exploreTitle,
                        children: "Explore our study destinations!"
                    }),
                    studyCountries.map((country, ind)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (StudyDestination_module_default()).exploreDivBlue,
                            style: {
                                backgroundColor: country.bgcolor
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (StudyDestination_module_default()).alignTop,
                                    id: country.title.replace(/ /g, "")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (StudyDestination_module_default()).studyServSection,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                            className: country.type === "one" ? (StudyDestination_module_default()).row : "",
                                            children: country.type === "one" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                        xs: 12,
                                                        lg: 6,
                                                        className: (StudyDestination_module_default()).txtPosition,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (StudyDestination_module_default()).studyContent,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    className: "mb-4",
                                                                    children: country.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: country.description
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                    children: "Quick facts"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                    className: "pl-0",
                                                                    children: country.quickfacts.map((fact, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: fact
                                                                        }, index))
                                                                }),
                                                                query.slug && !country.link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: `${(StudyDestination_module_default()).enqBtn} btn ${(0,helpers/* isFrappeOrJotFormClass */.gd)(props?.pageData?.meta?.jotforms[0]?.jotformid)}`,
                                                                    children: "Enquire Now"
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: country.link,
                                                                    children: "Know More"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                        xs: 12,
                                                        lg: 6,
                                                        className: `${(StudyDestination_module_default()).imgPosition}  ${(StudyDestination_module_default()).justifyContentEnd}`,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (StudyDestination_module_default()).platformDivImg,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (StudyDestination_module_default()).picRound,
                                                                    style: {
                                                                        backgroundColor: country?.bgCircleColor
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (StudyDestination_module_default()).pica,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: country?.image1 || "/cana_a.svg",
                                                                        width: 200,
                                                                        height: 200,
                                                                        alt: country?.imageAltTag1
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (StudyDestination_module_default()).picb,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: country?.image2 || "/cana_b.svg",
                                                                        width: 200,
                                                                        height: 280,
                                                                        alt: country?.imageAltTag2
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (StudyDestination_module_default()).picc,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: country?.image3 || "/cana_c.svg",
                                                                        width: 200,
                                                                        height: 280,
                                                                        alt: country?.imageAltTag3
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (StudyDestination_module_default()).picd,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: country?.image4 || "/cana_d.svg",
                                                                        width: 200,
                                                                        height: 200,
                                                                        alt: country?.imageAltTag4
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                        xs: 12,
                                                        lg: 6,
                                                        className: `${(StudyDestination_module_default()).imgPosition} ${(StudyDestination_module_default()).justifyContentStart}`,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (StudyDestination_module_default()).platformDivImg,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (StudyDestination_module_default()).picRound,
                                                                    style: {
                                                                        backgroundColor: country?.bgCircleColor
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (StudyDestination_module_default()).pica,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: country?.image1 || "/cana_a.svg",
                                                                        width: 200,
                                                                        height: 200,
                                                                        alt: country?.imageAltTag1
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (StudyDestination_module_default()).picb,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: country?.image2 || "/cana_b.svg",
                                                                        width: 200,
                                                                        height: 280,
                                                                        alt: country?.imageAltTag2
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (StudyDestination_module_default()).picc,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: country?.image3 || "/cana_c.svg",
                                                                        width: 200,
                                                                        height: 280,
                                                                        alt: country?.imageAltTag3
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (StudyDestination_module_default()).picd,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: country?.image4 || "/cana_c.svg",
                                                                        width: 200,
                                                                        height: 200,
                                                                        alt: country?.imageAltTag4
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                        xs: 12,
                                                        lg: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (StudyDestination_module_default()).studyContent,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    className: "mb-4",
                                                                    children: country.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: country.description
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                    children: "Quick facts"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                    className: "pl-0",
                                                                    children: country.quickfacts.map((fact, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: fact
                                                                        }, index))
                                                                }),
                                                                query.slug && !country.link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: `${(StudyDestination_module_default()).enqBtn} btn ${(0,helpers/* isFrappeOrJotFormClass */.gd)(props?.pageData?.meta?.jotforms[0]?.jotformid)}`,
                                                                    children: "Enquire Now"
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: country.link,
                                                                    children: "Know More"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        }, ind);
                    })
                ]
            }),
            props.pageData?.videoTestimonial && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoTestimonials/* default */.Z, {
                ...props.pageData.videoTestimonial
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WebinarEvents["default"], {
                headingLevel: 2
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (StudyDestination_module_default()).uniTieUp,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UniTieUp["default"], {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (StudyDestination_module_default()).homePageLatestKcUpdates,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(kcNewlatestupdates["default"], {
                    ...props
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (StudyDestination_module_default()).homePageBlogs,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedBlogs["default"], {})
            }),
            props?.countryData?.[0]?.faq && /*#__PURE__*/ (0,jsx_runtime.jsx)(FrequentlyAskedQuestions/* default */.Z, {
                ...props?.countryData?.[0]?.faq
            }),
            props?.pageData?.needGuidance && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewNeedGuidance/* default */.Z, {
                data: props?.pageData?.needGuidance,
                jotforms: props?.pageData?.meta?.jotforms,
                externalLink: props?.pageData?.externalLink
            })
        ]
    });
};
/* harmony default export */ var components_StudyDestination = (StudyDestination);


/***/ }),

/***/ 97761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73017);
/* harmony import */ var _styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31555);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_fetchUtil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40607);









const TopTieUpsOfKC = ()=>{
    const { 0: topTieUps , 1: setTopTieUps  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_utils_fetchUtil__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(`${"https://cms.studies-overseas.com"}/top-university-tie-ups`, "GET", {}, "", false).then((res)=>setTopTieUps(res));
    }, []);
    return topTieUps ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "uni-tie-upmain",
        className: (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().uniTieUp),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: "unitieuptxt",
                        className: `text-center ${(_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading)}`,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().uniDiv),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: topTieUps?.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: topTieUps?.description
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    id: "unitieupLogo",
                    className: "text-center",
                    children: topTieUps?.images?.length > 0 && topTieUps.images.map((images, index)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            xl: 3,
                            md: 3,
                            xs: 6,
                            className: `${(_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().cols)} ${index > 3 ? (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().borderl0) : ""}`,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().unidiv),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    src: images?.imageUrl,
                                    alt: images?.imageAltTag,
                                    width: 174,
                                    height: 75
                                })
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-center mt-3",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: "/universities",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            id: "moreUniId",
                            className: (_styles_Unitieup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().viewMore),
                            children: "More Universities"
                        })
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["default"] = (TopTieUpsOfKC);


/***/ }),

/***/ 12978:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"hide-scrollbar":"TabNav_hide-scrollbar__V2Wqm","tabNav":"TabNav_tabNav__qTSaW","tabNavScroller":"TabNav_tabNavScroller__tnVb0","tabNavItem":"TabNav_tabNavItem__HgVV8","active":"TabNav_active__l201b","edgeFadeLeft":"TabNav_edgeFadeLeft__xqSgY","edgeFadeRight":"TabNav_edgeFadeRight__llVEm"};

/***/ }),

/***/ 90784:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"studyDestinationBg":"StudyDestination_studyDestinationBg__GyeZw","mainContent":"StudyDestination_mainContent__0KcoG","searchStudyDesti":"StudyDestination_searchStudyDesti__YUKcB","searchPan":"StudyDestination_searchPan__soA7T","searchBox":"StudyDestination_searchBox__ccd0b","searchtxt":"StudyDestination_searchtxt__6a1VD","subscribeForm":"StudyDestination_subscribeForm__Oifo3","Strengths":"StudyDestination_Strengths__mPCkr","exploreDiv":"StudyDestination_exploreDiv__t4vL_","exploreDivBlue":"StudyDestination_exploreDivBlue__3VBhS","alignTop":"StudyDestination_alignTop__jdLWO","exploreDivLightPing":"StudyDestination_exploreDivLightPing__jMQMG","stickyHead":"StudyDestination_stickyHead__m_LrT","headerDisplay":"StudyDestination_headerDisplay__QQesL","exploreTitle":"StudyDestination_exploreTitle__ucJt8","studyServSection":"StudyDestination_studyServSection__4CJcO","row":"StudyDestination_row__6CZXO","imgPosition":"StudyDestination_imgPosition__oNDt9","justifyContentEnd":"StudyDestination_justifyContentEnd__gQLQ_","justifyContentStart":"StudyDestination_justifyContentStart__nCt31","studyContent":"StudyDestination_studyContent__r4X2o","enqBtn":"StudyDestination_enqBtn__x7Nsm","studyContentpink":"StudyDestination_studyContentpink__H7qxy","platformDivImg":"StudyDestination_platformDivImg__P6Iji","picRound":"StudyDestination_picRound__g8k1K","pica":"StudyDestination_pica__xf3GR","picb":"StudyDestination_picb__1dKG9","picc":"StudyDestination_picc__av001","picd":"StudyDestination_picd__fJNyU","uniTieUp":"StudyDestination_uniTieUp__4g_kV","cols":"StudyDestination_cols__2moCa","borderl0":"StudyDestination_borderl0__uSoBv","border0":"StudyDestination_border0__tQfKZ","viewMore":"StudyDestination_viewMore__IxdGu","homePageLatestKcUpdates":"StudyDestination_homePageLatestKcUpdates___kpDX","homePageBlogs":"StudyDestination_homePageBlogs__z5HeR","breadcrum":"StudyDestination_breadcrum__WnNrY","active":"StudyDestination_active___yrfo"};

/***/ }),

/***/ 73017:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uniTieUp":"Unitieup_uniTieUp__tb7S6","cols":"Unitieup_cols__vvM4K","borderl0":"Unitieup_borderl0__x9LQV","border0":"Unitieup_border0__pocJi","viewMore":"Unitieup_viewMore__jrZKp","heading":"Unitieup_heading__tu7PU"};

/***/ }),

/***/ 98745:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 98322:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 26699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/Anchor.js + 10 modules
var Anchor = __webpack_require__(23646);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/BreadcrumbItem.js





const defaultProps = {
  active: false,
  linkProps: {}
};
const BreadcrumbItem = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  active,
  children,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'li',
  linkAs: LinkComponent = Anchor/* default */.Z,
  linkProps,
  href,
  title,
  target,
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb-item');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(prefix, className, {
      active
    }),
    "aria-current": active ? 'page' : undefined,
    children: active ? children : /*#__PURE__*/(0,jsx_runtime.jsx)(LinkComponent, { ...linkProps,
      href: href,
      title: title,
      target: target,
      children: children
    })
  });
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
BreadcrumbItem.defaultProps = defaultProps;
/* harmony default export */ var esm_BreadcrumbItem = (BreadcrumbItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js





const Breadcrumb_defaultProps = {
  label: 'breadcrumb',
  listProps: {}
};
const Breadcrumb = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  listProps,
  children,
  label,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'nav',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    "aria-label": label,
    className: className,
    ref: ref,
    ...props,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("ol", { ...listProps,
      className: classnames_default()(prefix, listProps == null ? void 0 : listProps.className),
      children: children
    })
  });
});
Breadcrumb.displayName = 'Breadcrumb';
Breadcrumb.defaultProps = Breadcrumb_defaultProps;
/* harmony default export */ var esm_Breadcrumb = (Object.assign(Breadcrumb, {
  Item: esm_BreadcrumbItem
}));

/***/ })

}]);